'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { Component } from 'react';
import NavListItem from './NavListItem';
import { jsx as _jsx } from "react/jsx-runtime";
export default class NestedNavItem extends Component {
  render() {
    const _this$props = this.props,
      {
        children
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(NavListItem, Object.assign({
      iconRight: children != null ? 'down' : null
    }, rest, {
      children: children
    }));
  }
}
NestedNavItem.displayName = 'NestedNavItem';
NestedNavItem.propTypes = Object.assign({}, NavListItem.propTypes);
NestedNavItem.defaultProps = Object.assign({}, NavListItem.defaultProps);